import { StoreSnapshot } from '@xstate/store-react';
import { store } from '../../store/store';
import { StoreContext } from '../../models/store/context';

/**
 * @description getJourneyType is a selector function that retrieves the journey type from the store's state.
 * It accesses the store's snapshot and returns the journeyType from the context. If there is an error during this process, it catches the error, logs it to the console, and returns undefined.
 * @returns {StoreSnapshot<StoreContext>['context']['journeyType']} The journey type from the store, or undefined if there was an error
 * @example
 * const journeyType = getJourneyType.get();
 * console.log(journeyType); // Output: 'modelSerial' or 'registration' depending on the current journey type in the store
 */
export const getJourneyType = {
  get: (): StoreSnapshot<StoreContext>['context']['journeyType'] => {
    const storeInstance = store.getSnapshot();
    return storeInstance.context.journeyType;
  },
};
